import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import localeCode from 'locale-code';
import { Iso6391Helper } from '../../../shared/services/utils/iso-639-1-helper.service';

@Component({
  selector: 'def-locale-selector',
  templateUrl: './locale-selector.component.html',
  styleUrls: ['./locale-selector.component.scss'],
})
export class LocaleSelectorComponent implements OnInit {
  languageControl: FormControl = new FormControl(null, Validators.required);
  availableLangs: {label: string; value: string}[] = [];

  constructor(
    private translateService: TranslateService,
    private iso6391Helper: Iso6391Helper,
  ) {
  }

  ngOnInit(): void {
    this.initListOfLanguages();
    this.setCurrentTranslateLanguage();
  }

  languageChanged(): void {
    this.translateService.use(this.languageControl.value);
  }

  private initListOfLanguages(): void {
    for (const availableLang of this.translateService.getLangs()) {
      const lang = {
        label: this.getLanguageLabel(availableLang),
        value: availableLang,
      };
      this.availableLangs.push(lang);
    }

    this.availableLangs.sort((a, b) => a.label.localeCompare(b.label));
  }

  /**
   * Returns the label to display based on language code supported by our app
   *
   * @param languageCode Language code as found in environment files
   */
  private getLanguageLabel(languageCode: string): string {
    if (this.iso6391Helper.validate(languageCode)) {
      return this.iso6391Helper.getNativeName(languageCode);
    }

    if (localeCode.validateLanguageCode(languageCode)) {
      return localeCode.getLanguageNativeName(languageCode) + ' - ' + localeCode.getCountryName(languageCode);
    }

    return languageCode;
  }

  private setCurrentTranslateLanguage() {
    this.languageControl.patchValue(this.translateService.currentLang);
  }
}
